import { Component, Injector, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { skip } from 'rxjs';

@Component({
  selector: 'page-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent extends BaseComponent implements OnInit {
  public titles = ['Meus dados', 'Endereco', 'Horarios', 'Dados profissionais'];
  public practitioner!: Practitioner;
  public practitionerRole: any;
  public activeTabIndex = 0;
  public selectedTabIndex = 0;
  public alerts: string[] = [];

  constructor(
    private injector: Injector,
    private route: ActivatedRoute,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.listenToTabQueryParam();
  }

  ngOnChanges(): void {
    this.evaluateAlerts();
  }

  evaluateAlerts(): void {
    this.alerts = [];

    if (this.checkIfIsFirstAccess()) {
      this.alerts = [
        'Complete seu <strong>perfil</strong>',
        'Defina suas <strong>Especialidades</strong>',
        'Defina suas <strong>Qualificacoes</strong>',
        'Defina sua <strong>Localidade</strong>',
      ];

      this.messageWarning = `
        <h4>Ola, seja bem-vindo(a). Para uma melhor experiencia:</h4>
        <ul>
          ${this.alerts.map((alert) => `<li>${alert}</li>`).join('')}
        </ul>
      `;

      return;
    }

    if (this.objectIsEmpty(this.practitionerRole)) {
      this.alerts.push('Defina suas <strong>Especialidades</strong>');
    }

    if (
      this.objectIsEmpty(this.practitioner?.qualifications) ||
      this.objectIsEmpty(this.practitioner?.certificates) ||
      this.objectIsEmpty(this.practitioner?.accessibilities) ||
      this.objectIsEmpty(this.practitioner?.communication)
    ) {
      this.alerts.push('Preencha suas <strong>Qualificacoes</strong>');
    }

    if (this.objectIsEmpty(this.practitioner?.address)) {
      this.alerts.push('Defina sua <strong>Localidade</strong>');
    }

    if (this.alerts.length > 0) {
      this.messageWarning = `
        <h4>Ola, seja bem-vindo(a). Para uma melhor experiencia:</h4>
        <ul>
          ${this.alerts.map((alert) => `<li>${alert}</li>`).join('')}
        </ul>
      `;
    } else {
      this.messageWarning = '';
    }
  }

  private listenToTabQueryParam(): void {
    this.route.queryParams.pipe(skip(1)).subscribe((params) => {
      const tabName = params['tab'];

      if (tabName) {
        const index = this.getTabIndexByName(tabName);

        if (this.selectedTabIndex !== index) {
          this.setTabIfAllowed(index);
        }
      }
    });
  }

  private setTabIfAllowed(index: number): void {
    if (this.isTabAllowed(index)) {
      this.selectedTabIndex = index;
    }
  }

  private isTabAllowed(index: number): boolean {
    return !(this.checkIfIsFirstAccess() && index > 0);
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabName = this.getTabNameByIndex(event.index);

    this.router.navigate([], {
      queryParams: { tab: tabName },
      queryParamsHandling: 'merge',
    });
  }

  getTabIndexByName(tabName: string): number {
    switch (tabName) {
      case 'perfil':
        return 0;
      case 'especialidade':
        return 1;
      case 'qualificacao':
        return 2;
      case 'localizacao':
        return 3;
      default:
        return 0;
    }
  }

  getTabNameByIndex(index: number): string {
    switch (index) {
      case 0:
        return 'perfil';
      case 1:
        return 'especialidade';
      case 2:
        return 'qualificacao';
      case 3:
        return 'localizacao';
      default:
        return 'perfil';
    }
  }

  public setPractitioner(practitioner: Practitioner): void {
    this.practitioner = practitioner;
    this.evaluateAlerts();
    this.showWarningMessage = true;
  }

  public setPractitionerRole(practitionerRole: any): void {
    this.practitionerRole = practitionerRole;
    this.evaluateAlerts();

    if (this.objectIsEmpty(practitionerRole)) {
      this.showWarningMessage = true;
    }
  }

  checkIfIsFirstAccess(): boolean {
    const isFirstAccess = localStorage.getItem('isFirstAccess') === 'true';

    if (isFirstAccess) {
      this.showWarningMessage = true;
    }

    return isFirstAccess;
  }

  objectIsEmpty(obj?: any): boolean {
    if (obj == null) {
      return true;
    }

    if (Array.isArray(obj)) {
      return obj.length === 0;
    }

    if (typeof obj === 'object') {
      const values = Object.values(obj);
      return values.every((value) => value === null || value === undefined || (typeof value === 'string' && value.trim() === ''));
    }

    return false;
  }
}
